import React from "react";
import { Link } from "react-router-dom";
import { Content } from "../../components/Layout";
import { Box, Flex } from "../../components/Flex";
import { Paragraph, Title } from "../../components/Text";
import { Button, TextButton } from "../../components/Button";
import { CloseIcon } from "../../icons/CloseIcon";
import { renderFieldContent } from "../../components/Layout";
import { fixPackageSize, formatDate, getContractStatus } from "../../utils";
import { Badge } from "../../components/Circle";
import { EditIcon } from "../../icons/EditIcon";
import { DownloadIcon } from "../../icons/DownloadIcon";
import { RemoveIcon } from "../../icons/RemoveIcon";

const LicenseDetails = ({
    org,
    data={},
    loading,
    onClose,
    isAdmin,
    downloadLicense,
    editLicense,
    deleteLicense
}) => {
    const fields = {
        main: [
            isAdmin && !org && { label: "Organization", attr: "orgName", render: (d, k) => <Link to={`/organisations/${k.orgAlias}`}>{d}</Link> },
            { label: "Expiration Date", attr: "expiryDate", render: (d) => formatDate(d, "DD-MMM-YYYY") },
            { attr: "notes" },
        ],
        file: [
            { attr: "fileName", render: (d, k) => (
                <TextButton
                    disabled={loading}
                    maxWidth="390px"
                    style={{ fontWeight: 700 }}
                    onClick={() => downloadLicense(k.id)}
                >
                    {d}
                </TextButton>
            )},
            { label: "File size", attr: "fileSize", render: (d) => fixPackageSize(d) },
            isAdmin && { label: "Uploaded by", attr: "uploadedBy" },
            { label: "Upload datetime", attr: "uploadDatetime", render: (d) => formatDate(d, "DD-MMM-YYYY HH:mm:ss") },
        ]
    };

    let expired = getContractStatus(data.expiryDate);

    return(
        <Content background="FFFFFF" gap={{ bottom: 18 }}>
            <Flex width="100%" justify="space-between" margin={{ bottom: "24px"}}>
                <Flex align="center" gap={{ right: 8 }}>
                    {<Badge size={12} color={ expired < 0 ? "var(--sp-error-color)" : expired == 0 ? "var(--sp-warning-color)" : "var(--sp-success-color)"} />}
                    <Title h4 isLoading={loading}>
                        {typeof data.fileName === "string" ? data.fileName.substring(0, data.fileName.lastIndexOf(".")) : data.fileName}
                    </Title>
                </Flex>
                <CloseIcon onClick={onClose} />
            </Flex>
            <Flex flex={1} gap={{ right: 32 }}>
                <Flex flex={1} direction="column" gap={{ bottom: 12 }}>
                    {renderFieldContent(fields.main, data)}
                </Flex>
                <Flex direction="column">
                    <Box flatten background="#F0F4FB" gap={{ bottom: 8 }}>
                        <Title h6 capitalize>License File</Title>
                        {renderFieldContent(fields.file, data)}
                    </Box>
                </Flex>
            </Flex>
            <Flex gap={{ right: 12 }}>
                <Button onClick={() => downloadLicense(data.id)}>
                    <DownloadIcon size={20} />
                    Download
                </Button>
                {isAdmin &&
                <>
                    <Button onClick={() => editLicense(data)}>
                        <EditIcon size={20} />
                        Edit License
                    </Button>
                    <Button
                        danger
                        disabled={loading || !data}
                        onClick={() => deleteLicense({
                            content: <Paragraph>Are you sure you want to delete the <b>{data.fileName}</b> license for <b>{data.orgName}</b>?</Paragraph>,
                            id: data.id
                        })}
                    >
                        <RemoveIcon size={20} />
                        Delete
                    </Button>
                </>}
            </Flex>
        </Content>
    );
};

export { LicenseDetails }